import React from "react";

const basicInputClass =
  "bg-white focus:outline-none focus:shadow-outline border border-gray-300 rounded py-1 px-2 block w-full appearance-none leading-normal";

class TextArea extends React.PureComponent {
  constructor(props) {
    super(props);

    this.textareaRef = React.createRef();

    this.handleMouseDown = this.handleMouseDown.bind(this);
    this.handleMouseUp = this.handleMouseUp.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleMouseDown(e) {
    if (e.detail === 2) {
      e.preventDefault();
    }
  }

  handleMouseUp(e) {
    if (e.detail !== 2) return;

    const textarea = this.textareaRef.current;
    const value = textarea.value;

    let cursorPos = 0;

    if (document.caretPositionFromPoint) {
      const pos = document.caretPositionFromPoint(e.clientX, e.clientY);
      cursorPos = pos.offset;
    } else if (document.caretRangeFromPoint) {
      const range = document.caretRangeFromPoint(e.clientX, e.clientY);
      cursorPos = range.startOffset;
    }

    const delimiters = [",", "[", "]", " ", '"', "'", "\n"];

    if (value[cursorPos] && delimiters.includes(value[cursorPos])) {
      return;
    }

    let start = cursorPos;
    while (start > 0 && !delimiters.includes(value[start - 1])) {
      start--;
    }

    let end = cursorPos;
    while (end < value.length && !delimiters.includes(value[end])) {
      end++;
    }

    textarea.setSelectionRange(start, end);
  }

  handleChange(e) {
    const { value } = e.target;
    const { handleChange } = this.props;

    if (handleChange) {
      handleChange(value);
    }
  }

  render() {
    const { rows = 4, inputValue } = this.props;
    return (
      <textarea
        className={basicInputClass}
        ref={this.textareaRef}
        value={inputValue}
        onMouseDown={this.handleMouseDown}
        onMouseUp={this.handleMouseUp}
        onChange={this.handleChange}
        rows={rows}
      />
    );
  }
}

export default TextArea;
